import styled from 'styled-components';

export const CardLayer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  pointer-events: none;

  & > * {
    pointer-events: all;
  }
`;
